import { useApp } from '@/context/AppContext';

export default function AddCustomerModal() {
  const { addCustomer, closeModal, team } = useApp();

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);
    addCustomer({
      name:            data.name,
      phone:           data.phone,
      email:           data.email,
      mrr:             Number(data.mrr) || 120,
      addr:            data.addr,
      poolGal:         data.poolGal || '15,000',
      gateCode:        data.gateCode || '',
      tech:            data.tech,
      controller:      data.controller || '',
      pets:            'None',
      nextVisit:       'TBD',
      notes:           data.notes || '',
      since:           'May 2026',
      notifyOnArrival: data.notifyOnArrival === 'on',
    });
    closeModal();
  };

  return (
    <div className="modal">
      <div className="modal-head">
        <span className="modal-title">Add New Customer</span>
        <button className="btn btn-ghost btn-sm" onClick={closeModal}>✕</button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="field">
              <label>Full Name *</label>
              <input name="name" placeholder="Smith, John" required />
            </div>
            <div className="field">
              <label>Phone</label>
              <input name="phone" placeholder="(555) 000-0000" />
            </div>
          </div>
          <div className="form-row">
            <div className="field">
              <label>Email</label>
              <input name="email" type="email" placeholder="john@email.com" />
            </div>
            <div className="field">
              <label>MRR ($)</label>
              <input name="mrr" type="number" placeholder="120" min="0" />
            </div>
          </div>
          <div className="field">
            <label>Address *</label>
            <input name="addr" placeholder="123 Main St" required />
          </div>
          <div className="form-row">
            <div className="field">
              <label>Pool Size (gal)</label>
              <input name="poolGal" placeholder="15,000" />
            </div>
            <div className="field">
              <label>Gate Code</label>
              <input name="gateCode" placeholder="1234" />
            </div>
          </div>
          <div className="form-row">
            <div className="field">
              <label>Assigned Tech</label>
              <select name="tech" defaultValue="">
                <option value="">Unassigned</option>
                {team.map(t => <option key={t.id} value={t.name}>{t.name}</option>)}
              </select>
              {team.length === 0 && (
                <div style={{ fontSize: 11, color: 'var(--t3)', marginTop: 4 }}>
                  No technicians yet — add one in the Team screen.
                </div>
              )}
            </div>
            <div className="field">
              <label>Controller</label>
              <select name="controller">
                <option value="">None</option>
                <option>pentair</option>
                <option>jandy</option>
                <option>hayward</option>
                <option>attendant</option>
              </select>
            </div>
          </div>
          <div className="field">
            <label>Notes</label>
            <textarea name="notes" placeholder="Gate codes, pets, special instructions…" />
          </div>
          <div className="field" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <input id="notify-on-arrival" name="notifyOnArrival" type="checkbox" defaultChecked />
            <label htmlFor="notify-on-arrival" style={{ margin: 0, fontWeight: 500 }}>
              Text this customer when their tech arrives
              <div style={{ fontSize: 11, color: 'var(--t3)', fontWeight: 400, marginTop: 2 }}>
                Sends an SMS the first time their stop is entered on a route — requires Twilio configured.
              </div>
            </label>
          </div>
          <div className="modal-foot">
            <button type="button" className="btn btn-ghost" onClick={closeModal}>Cancel</button>
            <button type="submit" className="btn btn-primary">Add Customer</button>
          </div>
        </form>
      </div>
    </div>
  );
}
